import '../App.css'; // Import the App.css styles
import React, { useMemo, forwardRef, memo, useEffect } from 'react';
import { Box } from '@mui/material';
import { FixedSizeList as List } from 'react-window';

const isMobile = () => {
  const ua = navigator.userAgent;
  const isMobile = /iPhone|iPad|iPod|Android/i.test(ua);
  return isMobile ;
};

const BackgroundPattern = forwardRef(({ totalHeight }, ref) => {
  const svgsPerRow = 20;
  const rowHeight = 5;
  
  // Calculate row height in pixels based on window width
  const rowHeightPx = (rowHeight / 100) * window.innerWidth;

  // Calculate how many rows are needed
  const calculateNumRows = (totalHeight) => {
    return Math.ceil(totalHeight / rowHeightPx);
  };

  // using useMemo to calculate the styles once during initial render
  const predefinedStyles = useMemo(() => {
    const numRows = calculateNumRows(totalHeight);
    return Array.from({ length: numRows }, () =>
      Array.from({ length: svgsPerRow }, () => Math.random() < 0.5)
    );
  }, [totalHeight]);

  const Row = memo(({ index, style }) => (
    <Box style={style} className="pattern-row">
      {!isMobile() && predefinedStyles[index].map((isBright, svgIndex) => (
        <Box
          key={`${index}-${svgIndex}`}
          className={`icon-container${isBright ? ' bright' : ''} ${  
            (index + svgIndex) % 2 === 0 ? 'bulb-icon' : 'heart-icon'}`}
        />
      ))}
    </Box>
  ));

  return (
    <Box ref={ref} className="background-pattern" style={{ height: `${totalHeight}px` }}>
      <List
        height={totalHeight}
        itemCount={predefinedStyles.length}
        itemSize={rowHeightPx}
        width={window.innerWidth}
      >
        {Row}
      </List>
    </Box>
  );
});

export default memo(BackgroundPattern);